import { BioLibApiError } from '@biolibtech/biolib-js';
import { authApi } from './authApi';
import { IAuthStatus } from './authApi.types';
import { dispatchQuery } from '../state';
import LocalStorageManager from '@features/userFlow/utils/LocalStorageManager';

export function isOAuthReAuthenticationRequiredError(error: unknown): boolean {
    return (
        error instanceof BioLibApiError &&
        error.validationErrors?.code === 'oauth_re_authentication_required'
    );
}

export function redirectToReAuthentication(authorizationUrl: string, isPopup?: boolean): void {
    LocalStorageManager.signInState = { redirectTo: window.location.pathname, isPopup };
    window.location.href = authorizationUrl;
}

export async function startReAuthentication(): Promise<boolean> {
    const authStatus = await dispatchQuery<IAuthStatus, { eager?: boolean }>(
        authApi.endpoints.getAuthStatus,
        { eager: true },
        { forceRefetch: true },
    );

    if (!authStatus.should_re_authenticate || !authStatus.authorization_url) {
        return false;
    }

    redirectToReAuthentication(authStatus.authorization_url);
    return true;
}
